import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants/src/shared';

import { Heading } from '../../atoms/Heading';
import { rem } from '../../helpers';

export const $Header = styled.header<{ $hasMargin: boolean }>`
  @media ${media.minWidth.sm} {
    display: flex;
    align-items: start;
    justify-content: space-between;
    > div:not(:last-child) {
      padding-right: 0.5rem;
      flex: 1;
    }
    > div:not(:first-child) {
      padding-left: 0.5rem;
      flex: 0;
    }
    > div {
      margin-bottom: ${({ $hasMargin }) => ($hasMargin ? '1rem' : null)};
    }
    h1 {
      min-height: ${rem(41)};
    }
  }
`;

export const $HeadingCustomized = styled(Heading)`
  @media ${media.maxWidth.xs} {
    font-size: ${({ level }) => (level === 1 ? '1.5rem' : null)};
  }

  padding-right: 1rem;
`;

export const $HeaderTitle = styled.div`
  display: flex;
`;
